import { useMemo } from 'react';
import { customGenericStyles } from '@rsos/base-components/Select/Select.styles';

interface SelectControlState {
  selectProps: {
    theme: {
      colors: {
        lightDanger: string;
        heavyLineOutline: string;
      };
    };
  };
  isDisabled: boolean;
}

/** Outlines the control in red while the field has a visible error. */
export function useSelectStyles(error?: string): Record<string, unknown> {
  return useMemo(() => {
    const baseStyles = customGenericStyles as Record<string, unknown>;
    return {
      ...baseStyles,
      control: (
        base: Record<string, unknown>,
        state: SelectControlState,
      ): Record<string, unknown> => ({
        ...((
          baseStyles.control as (
            base: Record<string, unknown>,
            state: SelectControlState,
          ) => Record<string, unknown>
        )?.(base, state) || {}),
        borderColor: error
          ? state.selectProps.theme.colors.lightDanger
          : state.selectProps.theme.colors.heavyLineOutline,
        opacity: state.isDisabled ? 0.5 : 1,
        cursor: state.isDisabled ? 'not-allowed' : 'pointer',
        pointerEvents: 'auto',
      }),
    };
  }, [error]);
}
